"use client";

import { c as _c } from "react/compiler-runtime";
import type { CookieContextType, CookieKey, CookieValue, FilterResults, GetCookie } from "@/types/cookies";
import type { ReactNode } from "react";
import { createContext, useCallback, useContext } from "react";
import { useClientTz } from "@/hooks/use-client-tz";
import { COOKIES } from "@/types/cookies";
import Cookies from "js-cookie";
const CookieContext = createContext<CookieContextType | undefined>(undefined);
export function CookieProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  useClientTz();
  const get = _temp;
  const set = _temp2;
  const getTargeted = _temp3;
  const remove = _temp4;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => getTargeted(Object.keys(COOKIES));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getAll = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      get,
      set,
      remove,
      getAll,
      getTargeted
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const contextValue = t2 satisfies CookieContextType;
  let t3;
  if ($[2] !== children) {
    t3 = <CookieContext.Provider value={contextValue}>{children}</CookieContext.Provider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp4(key_1) {
  Cookies.remove(COOKIES[key_1]);
}
function _temp3(k) {
  const result = {} as Record<keyof CookieValue, string | undefined>;
  for (const kk of k) {
    result[kk] = Cookies.get(kk);
  }
  return result as FilterResults<V>;
}
function _temp2(key_0, value, options) {
  Cookies.set(COOKIES[key_0], value, options);
}
function _temp(key) {
  return Cookies.get(key) as GetCookie<K, true>;
}
export function useCookiesCtx() {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookies must be used within a CookieProvider");
  }
  return context;
}